<span  #highlightWord class="highlight">
    <ng-content></ng-content>
    <span class="highlight_svg">
        <img [src]="svgPath" [width]="widthWord">
    </span>
</span>
